import React from 'react';
import { connect } from 'react-redux';
import { BaseDialog } from '../layout/Dialog';
import Logger from '../../util/Logger';
import ResponsesList from './ResponsesList';
import { showDialog } from '../../actions/dialog';
import './NoteworthySelectionDialog.css';
import { ResponseSorts } from './ResponseSorts';
import Response from '../../models/Response';
import _ from 'lodash';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';

class NoteworthySelectionDialog extends React.Component {

  constructor (props) {
    super(props);

    const { user, event, responses } = props;
    if (!user) {
      Logger.assert('Missing user in NoteworthySelectionDialog component');
    }

    if (!event) {
      Logger.assert('Missing event in NoteworthySelectionDialog component');
    }

    if (!responses) {
      Logger.assert('Missing responses in NoteworthySelectionDialog component');
    }

    this.state = {
      originalNoteworthy: this.getCurrentNoteworthy(),
      noteworthy: this.getCurrentNoteworthy()
    };
  }

  getCurrentNoteworthy = () => {
    const { noteworthyPosts } = this.props;
    return (!noteworthyPosts || noteworthyPosts.length === 0) ? [] : noteworthyPosts;
  };

  onOkClicked = () => {
    const { onReceivedNoteworthyPosts } = this.props;
    const { noteworthy } = this.state;
    // If they have remove all of the ids, we disable the switch
    const switchEnabled = (noteworthy && noteworthy.length > 0);

    CreatorReportAnalytics.customizeNoteworthyModal('ok');

    if (switchEnabled) {
      onReceivedNoteworthyPosts(switchEnabled, noteworthy);
      // false signifies to the Dialog that nothing is restricting it from closing.
      return false;
    } else {
      // Nothing selected, show warning
      const { showDialog } = this.props;
      showDialog({
        title: 'No noteworthy selected',
        body: (
          <div>
            No noteworthy content was selected so this section of the report will remain disabled.
          </div>
        ),
        ok: 'Ok',
        onOk: () => {
          onReceivedNoteworthyPosts(switchEnabled, noteworthy);
          CreatorReportAnalytics.customizeNoNoteworthySelected('ok');
          this.onDialogHidden();
        },
        cancel: 'Cancel',
        onCancel: () => {
          CreatorReportAnalytics.customizeNoNoteworthySelected('cancel');
        }
      });

      // true signifies to the Dialog that we are restricting it from closing.
      return true;
    }
  };

  onDialogHidden = () => {
    const { onHidden } = this.props;
    onHidden();
  };

  handleItemClicked = (response) => {
    const { noteworthy } = this.state;
    const newNoteworthy = _.clone(noteworthy);
    let index = -1;
    for (let i = 0; i < newNoteworthy.length; ++i) {
      const item = newNoteworthy[i];
      if (Response.getId(item) === Response.getId(response)) {
        index = i;
        break;
      }
    }

    const isRemoving = index >= 0;
    if (isRemoving) {
      // If the clicked item is already contained as noteworthy - un mark it
      newNoteworthy.splice(index, 1);
    } else {
      // Mark the item as noteworthy and add it to the list
      newNoteworthy.push(response);
    }

    CreatorReportAnalytics.customizeNoteworthyModalCommentClicked(isRemoving, newNoteworthy.length);
    this.setState({ noteworthy: newNoteworthy });
  };

  onCancelClicked = () => {
    CreatorReportAnalytics.customizeNoteworthyModal('cancel');
    const { originalNoteworthy, noteworthy } = this.state;
    if (!_.isEqual(originalNoteworthy, noteworthy)) {
      const { showDialog } = this.props;
      showDialog({
        title: 'Unsaved changes',
        body: (
          <div>
            You have unsaved changes.
            &nbsp;Are you sure you want to continue without saving?
          </div>
        ),
        ok: 'Ok',
        onOk: () => {
          CreatorReportAnalytics.customizeNoteworthyUnsavedChangedModal('ok');
          this.onDialogHidden();
        },
        cancel: 'Cancel',
        onCancel: () => {
          CreatorReportAnalytics.customizeNoteworthyUnsavedChangedModal('cancel');
        }
      });
    } else {
      this.onDialogHidden();
    }
  };

  handleResetClicked = ($event) => {
    $event.preventDefault();
    CreatorReportAnalytics.customizeNoteworthyModal('reset');
    this.setState({ noteworthy: [] });
  };

  render () {
    const { event, responses } = this.props;
    const { noteworthy } = this.state;

    // Do not enable the reset button if they have no noteworthy
    const hasNoteworthy = (noteworthy && noteworthy.length > 0);
    return (
      <BaseDialog
        show={ true }
        closeOnClickOutside={ false }
        closeOnEscape={ false }
        customModalDialogClass="noteworthy-selection-dialog"
        customModalBodyClass="noteworthy-body"
        body={
          <div className="row no-gutters">
            <div className="col">
              <div className="noteworthy-upsell text-center">
                <strong>Noteworthy</strong>&nbsp;are content handpicked by you. Select the items you
                would like to showcase by clicking on them.
                <br />
                <i>If you have nothing to showcase, this section will be excluded from
                  your report.</i>
              </div>
              <ResponsesList
                onItemClicked={ this.handleItemClicked }
                event={ event }
                hasResponses={ true }
                noteworthy={ noteworthy }
                responses={ !!responses
                  ? ResponseSorts.sortByMostPopularTopLevel(responses)
                  : [] } />
            </div>
          </div>
        }
        ok="Ok"
        onOk={ this.onOkClicked }
        cancel="Cancel"
        onCancel={ () => {
          this.onCancelClicked();
          return true;
        } }
        extraActions={ [
          (
            <button
              disabled={ !hasNoteworthy }
              key="reset-button"
              className="btn btn-outline font-weight-semibold"
              onClick={ this.handleResetClicked }>
              Reset
            </button>
          )
        ] }
        hideDialog={ this.onDialogHidden }
      />
    );
  }
}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user
  };
};

export default connect(mapStateToProps, {
  showDialog
})(NoteworthySelectionDialog);
